import React from 'react'
import { AIGenerationMode } from '@marketing-milk/interfaces'

type Props = {
  mode: AIGenerationMode
  prompt: string
  onChange: (prompt: string) => void
}

const IMAGE_LIMIT = 500
const TEXT_LIMIT = 300

export function PromptEditor({ mode, prompt, onChange }: Props) {
  const limit = mode === 'image' ? IMAGE_LIMIT : TEXT_LIMIT
  const remaining = limit - prompt.length

  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-semibold text-gray-700">
        {mode === 'text' && 'Describe the copy changes you want'}
        {mode === 'image' && 'Describe the visual style or changes you want'}
        {mode === 'both' && 'Describe the overall changes you want'}
      </label>

      <textarea
        value={prompt}
        onChange={e => onChange(e.target.value)}
        maxLength={limit}
        rows={4}
        placeholder={
          mode === 'text'
            ? 'e.g. "Make the headline more urgent and the body copy shorter and punchier"'
            : mode === 'image'
            ? 'e.g. "Change the background to a warm sunset, keep the product in focus"'
            : 'e.g. "Summer sale theme: bright colors, urgent headline, short punchy copy"'
        }
        className="w-full rounded-xl border border-gray-300 px-4 py-3 text-sm text-gray-800 placeholder-gray-400 resize-none focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
      />

      <div className={`text-xs text-right ${remaining < 20 ? 'text-red-500' : 'text-gray-400'}`}>
        {remaining} characters remaining
      </div>

      {mode === 'text' && (
        <div className="text-xs text-gray-400 mt-1 space-y-0.5">
          <div>
            Facebook ad copy limits: headline ≤ 40 chars · primary text ≤ 125 chars · description ≤
            30 chars
          </div>
        </div>
      )}
    </div>
  )
}
